import RestClient from "@/api/utils/baseRestClient";
import { atmoClient } from "@/setup/clients/atmoClient";

class OrderFormRestClient extends RestClient {
  constructor(client, resource) {
    super(client, resource);
  }

  async send(orderFormUuid) {
    const url = this.buildUrl(`${orderFormUuid}/send/`);
    const response = await this.client.post(url);
    return this.toCamel(response.data);
  }

  async reimportResults(projectUuid, documentUuid) {
    const url = this.buildUrl("reimport_results/");
    const response = await this.client.post(
      url,
      this.toSnake({ project: projectUuid, documentUuid })
    );
    return this.toCamel(response.data);
  }
}

export const orderFormRestClient = new OrderFormRestClient(
  atmoClient,
  "orderforms"
);
